import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { Component, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TipoKitEmbalagemItem from "@/models/enum/tipoKitEmbalagemItem";
import TiposProduto from "@/models/enum/tiposProduto";
import FormaFarmaceuticaModel from "@/models/formaFarmaceuticaModel";
import KitEmbalagemCapsulaModel from "@/models/kitEmbalagemCapsulaModel";
import KitEmbalagemItemModel from "@/models/kitEmbalagemItemModel";
import KitEmbalagemModel from "@/models/kitEmbalagemModel";
import KitEmbalagemMoldeModel from "@/models/kitEmbalagemMoldeModel";
import ProdutoModel from "@/models/produto/produtoModel";
import UsuarioModel from "@/models/usuarioModel";
import capsulaService from "@/services/capsulaService";
import configuracaoRotuloService from "@/services/configuracaoRotuloService";
import formaFarmaceuticaService from "@/services/formaFarmaceuticaService";
import franquiaService from "@/services/franquiaService";
import kitEmbalagemService from "@/services/kitEmbalagemService";
import moldeService from "@/services/moldeService";
import produtoService from "@/services/produto/produtoService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { AppState, Getters, SessionActions } from "@/store/store";

import ReplicarSelecaoFranquiaComponent from "../replicarSelecaoFranquia/edit";
import replicarSelecaoFranquiaComponent from "../replicarSelecaoFranquia/edit.vue";

import "../crud.scss";
import "./edit.scss";

@Component({
    components: {
        textareaComponent,
        checkboxComponent,
        comboComponent,
        dataTooltipComponent,
        decimalComponent,
        fieldsetComponent,
        gridComponent,
        replicarSelecaoFranquiaComponent,
        buttonIncluirComponent,
        actionBarComponent,
        logEntidadeComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["HAS_PERMISSAO_PERFIL"] as Getters),
    },
})
export default class KitEmbalagemEditComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;

    model = new KitEmbalagemModel();
    modelId = 0;

    produtoComboId = 0;
    subGrupo: number = null;
    quantidade = 0;
    produtoPadrao = true;

    private replicarSelecaoFranquiaComponent: ReplicarSelecaoFranquiaComponent = null;
    private isAdmin = false;
    private isAdminFranqueador = false;

    private formaPriorizar = false;
    franquiaOptions: Array<Object> = [];

    formasFarmaceuticaOptions: Array<Object> = [];
    produtosOptions: Array<Object> = [];
    unidadesMedidaOptions: Array<Object> = [];
    tipoProdutoId: number = null;
    tipoProdutoOptions: Array<Object> = [
        { text: "Matéria-Prima", value: 0 },
        { text: "Semi-Acabado", value: 1 },
        { text: "Acabado", value: 2 },
        { text: "Embalagem", value: 3 },
        { text: "Cápsula", value: 4 },
        { text: "Floral", value: 6 },
    ];

    subGrupoOptions: Array<Object> = [
        { text: "Ativo", value: 0 },
        { text: "Flavorizante", value: 1 },
        { text: " Veículos/Excipientes", value: 2 },
        { text: "Recipiente", value: 3 },
        { text: "Tampa", value: 4 },
        { text: "Aplicador", value: 5 },
        { text: "Outros(Embalagens)", value: 6 },
    ];

    rotulosManipulacaoOptions: Array<Object> = [];
    tipoKitEmbalagemOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(TipoKitEmbalagemItem);
    capsulaComboId = 0;
    tipoKitEmbalagemItemId = 0;
    moldeComboId = 0;
    capsulasOptions: Array<Object> = [];
    moldeOptions: Array<Object> = [];
    quantidadeCapsula = 0;
    quantidadeMolde = 0;

    constructor() {
        super();

        this.model.ativo = true;
    }

    gridColumnsFormaFarmaceutica: Array<GridColumn> = [
        new GridColumn("descricao", "Descri\u00e7\u00e3o", GridColumnType.String),
        new GridColumn("priorizar", "Priorizar", GridColumnType.Boolean),
    ];

    gridColumnsCapacidadeCapsula: Array<GridColumn> = [
        new GridColumn("capsulaDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
        new GridColumn("quantidade", "Qtde", GridColumnType.Integer),
    ];

    gridColumnsCapacidadeMolde: Array<GridColumn> = [
        new GridColumn("moldeDescricao", "Descri\u00e7\u00e3o", GridColumnType.String), // Confirmar esse campo
        new GridColumn("quantidade", "Qtde", GridColumnType.Integer),
    ];

    gridColumnsProduto: Array<GridColumn> = [
        new GridColumn("produtoDescricao", "Descri\u00e7\u00e3o", GridColumnType.String),
        new GridColumn("quantidade", "Qtde", GridColumnType.Integer),
        new GridColumn("produtoPadrao", "Padrão", GridColumnType.Boolean),
        new GridColumn("tipoKitDescricao", "Tipo de cálculo", GridColumnType.String),
    ];

    private async load() {
        this.model = new KitEmbalagemModel();

        this.loadRotulosManipulacao();

        if (this.modelId > 0) {
            try {
                const data = await kitEmbalagemService.get(this.modelId);

                this.model.updateFrom(data);
            } catch {
                this.$router.back();
            }
        }
    }

    private async loadRotulosManipulacao() {
        try {
            this.rotulosManipulacaoOptions = await configuracaoRotuloService.comboCachedManipulacao(
                this.usuarioLogado.franquiaId,
            );
        } catch {}
    }

    private async save() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                if (this.model.formasFarmaceuticas.length <= 0) {
                    return this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.erroFormaFarmaceutica"));
                }
                if (this.model.kitEmbalagemItens.length <= 0) {
                    return this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.erroProduto"));
                }

                const sucesso = await kitEmbalagemService[!this.model.id ? "insert" : "update"](
                    this.model,
                    this.usuarioLogado.franquiaId,
                )
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    await this.$showInclusaoUpdate(this.model.id);

                    if (this.usuarioLogado.franquiaId != this.model.franquiaId && this.model.franquiaId != null) {
                        this.load();
                    } else {
                        this.$router.back();
                    }
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private cancel() {
        this.$router.back();
    }

    private onInclusaoFormaFarmaceutica() {
        const formaFarmaceuticaComponent = this.$el.querySelector("#formaFarmaceuticaId") as HTMLSelectElement;

        if (this.model.formaFarmaceuticaId > 0) {
            const alreadyExists = this.model.formasFarmaceuticas.some(p => p.id == this.model.formaFarmaceuticaId);

            if (!alreadyExists) {
                const formaFarmaceuticaModel = new FormaFarmaceuticaModel();

                formaFarmaceuticaModel.id = this.model.formaFarmaceuticaId;
                formaFarmaceuticaModel.descricao = formaFarmaceuticaComponent.innerText;
                formaFarmaceuticaModel.itensPadroes = null;
                formaFarmaceuticaModel.priorizar = this.formaPriorizar;
                this.model.formasFarmaceuticas.push(formaFarmaceuticaModel);

                this.model.formaFarmaceuticaId = -1;
            }
        }
    }

    private onInclusaoCapacidadeEmbalagemCapsula() {
        const capsulaComponent = this.$el.querySelector("#capsulaComboId") as HTMLSelectElement;

        if (this.capsulaComboId > 0 && this.quantidadeCapsula > 0) {
            const alreadyExists = this.model.kitEmbalagemCapsulas.some(p => p.capsulaId == this.capsulaComboId);

            if (!alreadyExists) {
                const kitEmbalagemCapsula = new KitEmbalagemCapsulaModel();

                kitEmbalagemCapsula.capsulaId = this.capsulaComboId;
                kitEmbalagemCapsula.quantidade = this.quantidadeCapsula;
                kitEmbalagemCapsula.capsulaDescricao = capsulaComponent.innerText;
                this.model.kitEmbalagemCapsulas.push(kitEmbalagemCapsula);

                this.capsulaComboId = -1;
                this.quantidadeCapsula = 0;
            }
        }
    }

    private onInclusaoCapacidadeEmbalagemMolde() {
        const moldeComponent = this.$el.querySelector("#moldeComboId") as HTMLSelectElement;

        if (this.moldeComboId > 0 && this.quantidadeMolde > 0) {
            const alreadyExists = this.model.kitEmbalagemMoldes.some(p => p.moldeId == this.moldeComboId);

            if (!alreadyExists) {
                const kitEmbalagemMolde = new KitEmbalagemMoldeModel();

                kitEmbalagemMolde.moldeId = this.moldeComboId;
                kitEmbalagemMolde.quantidade = this.quantidadeMolde;
                kitEmbalagemMolde.moldeDescricao = moldeComponent.innerText;

                this.model.kitEmbalagemMoldes.push(kitEmbalagemMolde);

                this.moldeComboId = -1;
                this.quantidadeMolde = 0;
            }
        }
    }

    private async onInclusaoProduto() {
        const results = await Promise.all([this.$validator.validate("tipo"), this.$validator.validate("quantidade")]);

        const isValid = results.every(isValid => isValid);
        if (isValid) {
            if (this.produtoComboId > 0 && this.quantidade > 0) {
                const alreadyExists =
                    this.model.kitEmbalagemItens.filter(item => item.produtoId == this.produtoComboId).length > 0;

                if (!alreadyExists) {
                    const selected = await produtoService
                        .getById(this.produtoComboId)
                        .withLoading()
                        .resolveWithJSON<ProdutoModel>();

                    const item = new KitEmbalagemItemModel();
                    item.produtoId = this.produtoComboId;
                    item.produtoDescricao =
                        selected.descricao +
                        (selected.sinonimos != null && selected.sinonimos != "" ? " (" + selected.sinonimos + ")" : "");
                    item.quantidade = this.quantidade;
                    item.produtoPadrao = this.produtoPadrao;
                    item.tipo = this.tipoKitEmbalagemItemId;
                    item.tipoKitDescricao = EnumExtensions.getNamesAndValuesOrderedByNames(TipoKitEmbalagemItem).find(
                        i => i.value == item.tipo,
                    ).text;

                    this.model.kitEmbalagemItens.push(item);

                    this.produtoComboId = -1;
                    this.quantidade = 0;
                    this.tipoKitEmbalagemItemId = null;
                }
            }
        } else {
            this.$focusErrorField();
        }
    }

    private onRemoveFormaFarmaceutica(model: FormaFarmaceuticaModel) {
        this.model.formasFarmaceuticas = this.model.formasFarmaceuticas.filter(p => p != model);
    }

    private onRemoveCapacidadeEmbalagemCapsula(model: KitEmbalagemCapsulaModel) {
        this.model.kitEmbalagemCapsulas = this.model.kitEmbalagemCapsulas.filter(p => p != model);
    }

    private onRemoveCapacidadeEmbalagemMolde(model: KitEmbalagemMoldeModel) {
        this.model.kitEmbalagemMoldes = this.model.kitEmbalagemMoldes.filter(p => p != model);
    }

    private onRemoveProduto(model: KitEmbalagemItemModel) {
        this.model.kitEmbalagemItens = this.model.kitEmbalagemItens.filter(p => p != model);
    }

    private async onShowLogs(open: (slot: number, title: string, size: string) => {}) {
        open(2, this.$t("__.ts.histAlterKitEmb") as string, "lg-modal");
    }

    //@ts-ignore
    @Watch("tipoProdutoId")
    private onGrupoProdutoIdChanged() {
        if (this.tipoProdutoId >= 0) {
            switch (this.tipoProdutoId) {
                case TiposProduto.MateriaPrima:
                    this.subGrupoOptions = [
                        { text: "Ativo", value: 0 },
                        { text: "Flavorizante", value: 1 },
                        { text: " Veículos/Excipientes", value: 2 },
                    ];
                    break;
                case TiposProduto.Embalagem:
                    this.subGrupoOptions = [
                        { text: "Recipiente", value: 3 },
                        { text: "Tampa", value: 4 },
                        { text: "Aplicador", value: 5 },
                        { text: "Outros", value: 6 },
                    ];
                    break;
                default:
                    this.subGrupo = null;
                    this.subGrupoOptions = [
                        { text: "Ativo", value: 0 },
                        { text: "Flavorizante", value: 1 },
                        { text: " Veículos/Excipientes", value: 2 },
                        { text: "Recipiente", value: 3 },
                        { text: "Tampa", value: 4 },
                        { text: "Aplicador", value: 5 },
                        { text: "Outros(Embalagens)", value: 6 },
                    ];
                    break;
            }
        } else {
            this.subGrupo = null;
            this.subGrupoOptions = [
                { text: "Ativo", value: 0 },
                { text: "Flavorizante", value: 1 },
                { text: " Veículos/Excipientes", value: 2 },
                { text: "Recipiente", value: 3 },
                { text: "Tampa", value: 4 },
                { text: "Aplicador", value: 5 },
                { text: "Outros(Embalagens)", value: 6 },
            ];
        }
        this.atualizaProdutoOptions();
    }

    //@ts-ignore
    @Watch("subGrupo")
    private onSubGrupoChanged() {
        if (this.subGrupo >= 0 && this.subGrupo <= 2 && this.tipoProdutoId != TiposProduto.MateriaPrima) {
            this.tipoProdutoId = TiposProduto.MateriaPrima;
        } else if (this.subGrupo > 2 && this.subGrupo <= 6 && this.tipoProdutoId != TiposProduto.Embalagem) {
            this.tipoProdutoId = TiposProduto.Embalagem;
        } else {
            //nao chama pelo TipoProduto chama por aqui
            this.atualizaProdutoOptions();
        }
    }

    //@ts-ignore
    @Watch("produtoComboId")
    private async onProdutoIdChanged() {
        const data = await produtoService.comboCached(this.usuarioLogado.franquiaId);
        const produto = data.filter(p => p.value == this.produtoComboId);
        if (produto.length > 0) {
            this.tipoProdutoId = produto[0].tipoProdutoId;
            this.subGrupo = produto[0].subGrupo;
            this.$forceUpdate();
        }
    }

    private async atualizaProdutoOptions() {
        const data = await produtoService.comboCached(this.usuarioLogado.franquiaId);
        this.produtosOptions = data.filter(
            p =>
                (this.subGrupo == null ||
                    (p.subGrupo == this.subGrupo &&
                        (this.tipoProdutoId == null ||
                            this.tipoProdutoId == TiposProduto.MateriaPrima ||
                            this.tipoProdutoId == TiposProduto.Embalagem))) &&
                (this.tipoProdutoId == null || p.tipoProdutoId == this.tipoProdutoId),
        );
    }

    private async loadKitEmbalagemByParent() {
        if (this.modelId > 0) {
            const data = await kitEmbalagemService
                .getByParent(this.modelId, this.usuarioLogado.franquiaId)
                .withLoading()
                .resolveWithJSON<KitEmbalagemModel>();

            this.model = new KitEmbalagemModel();
            this.model.updateFrom(data);

            this.formasFarmaceuticaOptions = await formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId);

            this.capsulasOptions = await capsulaService.comboCached(this.usuarioLogado.franquiaId);
        }
    }

    private validarVisibilidadeBotoes(botao: string): boolean {
        if (botao == "replicar") {
            return this.model.id > 0 && this.model.kitEmbalagemPaiId == null && this.isAdminFranqueador;
        }

        if (botao == "remover") {
            return this.model.id > 0 && this.model.kitEmbalagemPaiId != null;
        }
    }

    private onReplicar() {
        this.replicarSelecaoFranquiaComponent = this.$refs
            .replicarSelecaoFranquiaComponent as ReplicarSelecaoFranquiaComponent;
        this.replicarSelecaoFranquiaComponent.openFranquias();
    }

    private async onConfirmReplicar(franquiasIds: Array<number>) {
        const idsFranquias = franquiasIds.toString();

        const sucesso = await kitEmbalagemService
            .replicar(this.model.id, idsFranquias)
            .withLoading()
            .resolveWithoutJSON();
        if (sucesso) {
            this.$showSuccess(this.$t("__.ts.replicou"), this.$t("__.ts.regisSalvosSucess"));
        }
    }

    private async loadFranquais() {
        if (this.isAdmin) {
            const franquias = await franquiaService.comboCached(this.usuarioLogado.franquiaId);
            this.franquiaOptions = franquias.map(item => ({
                value: item.id,
                text: item.nomeFantasia,
            }));
        }
    }

    private async onRemoveFilho() {
        const response = await this.$showExclusaoQuestion(`${this.$t("__.ts.desejaExcl")}${this.model.descricao}?`);

        if (response) {
            try {
                const sucesso = await kitEmbalagemService.delete(this.model.id, this.usuarioLogado.franquiaId);
                if (sucesso) {
                    this.load();
                    this.$showExclusao();
                }
            } catch {}
        }
    }
    //fim admin

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        this.isAdminFranqueador = await this.HAS_PERMISSAO_PERFIL(false, true, false);

        const response = await Promise.all([
            unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId),
            formaFarmaceuticaService.comboCached(this.usuarioLogado.franquiaId),
            capsulaService.comboCached(this.usuarioLogado.franquiaId),
            produtoService.comboCached(this.usuarioLogado.franquiaId),
            moldeService.comboCached(this.usuarioLogado.franquiaId),
        ]).catch(() => {});

        this.unidadesMedidaOptions = response[0];
        this.formasFarmaceuticaOptions = response[1];
        this.capsulasOptions = response[2];
        this.produtosOptions = response[3];
        this.moldeOptions = response[4];

        if (this.$route.params.id) {
            this.modelId = +this.$route.params.id;
        }

        this.load();
    }
}
